const languages = [
  {
    name: 'English',
    id: 'en',
  },
  {
    name: '中文（简体）',
    id: 'zh_CN',
  },
];

export const getLanguageName = (languageCode = '') => {
  const languageObj =
    languages.find(language => language.id === languageCode) || {};
  return languageObj.name || '';
};

export const getLanguageDirection = () => false;

export default languages;
